import React from "react";
import ForgotPassword from "./ForgotPassword";

const ResetPassword = () => {
  return <ForgotPassword />;
};

export default ResetPassword;
